import { allCountries } from 'country-telephone-data';
import 'flag-icons/css/flag-icons.min.css';

const iso2ToIso3: Record<string, string> = {
  ad: 'AND',
  ae: 'ARE',
  af: 'AFG',
  ag: 'ATG',
  ai: 'AIA',
  al: 'ALB',
  am: 'ARM',
  ao: 'AGO',
  aq: 'ATA',
  ar: 'ARG',
  as: 'ASM',
  at: 'AUT',
  au: 'AUS',
  aw: 'ABW',
  ax: 'ALA',
  az: 'AZE',
  ba: 'BIH',
  bb: 'BRB',
  bd: 'BGD',
  be: 'BEL',
  bf: 'BFA',
  bg: 'BGR',
  bh: 'BHR',
  bi: 'BDI',
  bj: 'BEN',
  bl: 'BLM',
  bm: 'BMU',
  bn: 'BRN',
  bo: 'BOL',
  bq: 'BES',
  br: 'BRA',
  bs: 'BHS',
  bt: 'BTN',
  bv: 'BVT',
  bw: 'BWA',
  by: 'BLR',
  bz: 'BLZ',
  ca: 'CAN',
  cc: 'CCK',
  cd: 'COD',
  cf: 'CAF',
  cg: 'COG',
  ch: 'CHE',
  ci: 'CIV',
  ck: 'COK',
  cl: 'CHL',
  cm: 'CMR',
  cn: 'CHN',
  co: 'COL',
  cr: 'CRI',
  cu: 'CUB',
  cv: 'CPV',
  cw: 'CUW',
  cx: 'CXR',
  cy: 'CYP',
  cz: 'CZE',
  de: 'DEU',
  dj: 'DJI',
  dk: 'DNK',
  dm: 'DMA',
  do: 'DOM',
  dz: 'DZA',
  ec: 'ECU',
  ee: 'EST',
  eg: 'EGY',
  eh: 'ESH',
  er: 'ERI',
  es: 'ESP',
  et: 'ETH',
  fi: 'FIN',
  fj: 'FJI',
  fk: 'FLK',
  fm: 'FSM',
  fo: 'FRO',
  fr: 'FRA',
  ga: 'GAB',
  gb: 'GBR',
  gd: 'GRD',
  ge: 'GEO',
  gf: 'GUF',
  gg: 'GGY',
  gh: 'GHA',
  gi: 'GIB',
  gl: 'GRL',
  gm: 'GMB',
  gn: 'GIN',
  gp: 'GLP',
  gq: 'GNQ',
  gr: 'GRC',
  gs: 'SGS',
  gt: 'GTM',
  gu: 'GUM',
  gw: 'GNB',
  gy: 'GUY',
  hk: 'HKG',
  hm: 'HMD',
  hn: 'HND',
  hr: 'HRV',
  ht: 'HTI',
  hu: 'HUN',
  id: 'IDN',
  ie: 'IRL',
  il: 'ISR',
  im: 'IMN',
  in: 'IND',
  io: 'IOT',
  iq: 'IRQ',
  ir: 'IRN',
  is: 'ISL',
  it: 'ITA',
  je: 'JEY',
  jm: 'JAM',
  jo: 'JOR',
  jp: 'JPN',
  ke: 'KEN',
  kg: 'KGZ',
  kh: 'KHM',
  ki: 'KIR',
  km: 'COM',
  kn: 'KNA',
  kp: 'PRK',
  kr: 'KOR',
  kw: 'KWT',
  ky: 'CYM',
  kz: 'KAZ',
  la: 'LAO',
  lb: 'LBN',
  lc: 'LCA',
  li: 'LIE',
  lk: 'LKA',
  lr: 'LBR',
  ls: 'LSO',
  lt: 'LTU',
  lu: 'LUX',
  lv: 'LVA',
  ly: 'LBY',
  ma: 'MAR',
  mc: 'MCO',
  md: 'MDA',
  me: 'MNE',
  mf: 'MAF',
  mg: 'MDG',
  mh: 'MHL',
  mk: 'MKD',
  ml: 'MLI',
  mm: 'MMR',
  mn: 'MNG',
  mo: 'MAC',
  mp: 'MNP',
  mq: 'MTQ',
  mr: 'MRT',
  ms: 'MSR',
  mt: 'MLT',
  mu: 'MUS',
  mv: 'MDV',
  mw: 'MWI',
  mx: 'MEX',
  my: 'MYS',
  mz: 'MOZ',
  na: 'NAM',
  nc: 'NCL',
  ne: 'NER',
  nf: 'NFK',
  ng: 'NGA',
  ni: 'NIC',
  nl: 'NLD',
  no: 'NOR',
  np: 'NPL',
  nr: 'NRU',
  nu: 'NIU',
  nz: 'NZL',
  om: 'OMN',
  pa: 'PAN',
  pe: 'PER',
  pf: 'PYF',
  pg: 'PNG',
  ph: 'PHL',
  pk: 'PAK',
  pl: 'POL',
  pm: 'SPM',
  pn: 'PCN',
  pr: 'PRI',
  ps: 'PSE',
  pt: 'PRT',
  pw: 'PLW',
  py: 'PRY',
  qa: 'QAT',
  re: 'REU',
  ro: 'ROU',
  rs: 'SRB',
  ru: 'RUS',
  rw: 'RWA',
  sa: 'SAU',
  sb: 'SLB',
  sc: 'SYC',
  sd: 'SDN',
  se: 'SWE',
  sg: 'SGP',
  sh: 'SHN',
  si: 'SVN',
  sj: 'SJM',
  sk: 'SVK',
  sl: 'SLE',
  sm: 'SMR',
  sn: 'SEN',
  so: 'SOM',
  sr: 'SUR',
  ss: 'SSD',
  st: 'STP',
  sv: 'SLV',
  sx: 'SXM',
  sy: 'SYR',
  sz: 'SWZ',
  tc: 'TCA',
  td: 'TCD',
  tf: 'ATF',
  tg: 'TGO',
  th: 'THA',
  tj: 'TJK',
  tk: 'TKL',
  tl: 'TLS',
  tm: 'TKM',
  tn: 'TUN',
  to: 'TON',
  tr: 'TUR',
  tt: 'TTO',
  tv: 'TUV',
  tw: 'TWN',
  tz: 'TZA',
  ua: 'UKR',
  ug: 'UGA',
  um: 'UMI',
  us: 'USA',
  uy: 'URY',
  uz: 'UZB',
  va: 'VAT',
  vc: 'VCT',
  ve: 'VEN',
  vg: 'VGB',
  vi: 'VIR',
  vn: 'VNM',
  vu: 'VUT',
  wf: 'WLF',
  ws: 'WSM',
  xk: 'XKX',
  ye: 'YEM',
  yt: 'MYT',
  za: 'ZAF',
  zm: 'ZMB',
  zw: 'ZWE',
};

export const getIso3 = (iso2: string): string => {
  return iso2ToIso3[iso2] || iso2.toUpperCase();
};

const cleanCountryName = (name: string): string => {
  return name?.replace(/\s*\(.*\)\s*$/, '')?.trim() || '';
};

export const getDialCode = (iso2: string): string => {
  const country = (allCountries || [])?.find((c) => c.iso2 === iso2);
  return country ? `+${country.dialCode}` : '';
};

export const dialCodeToIso2 = (dialCode: string): string => {
  const code = dialCode?.replace('+', '') || '';
  const country = (allCountries || [])?.find((c) => c.dialCode === code);
  return country?.iso2 || 'ae';
};

export const getPhoneMask = (iso2: string): string => {
  const country = (allCountries || [])?.find((c) => c.iso2 === iso2);
  if (!country?.format) return '';

  const dialLen = country?.dialCode?.length || 0;
  let dotCount = 0;
  let startIdx = 1;
  for (let i = 1; i < country.format.length; i++) {
    if (country.format[i] === '.') {
      dotCount++;
      if (dotCount === dialLen) {
        startIdx = i + 1;
        break;
      }
    }
  }

  let mask = country.format.substring(startIdx);
  if (mask.startsWith('-') || mask.startsWith(' ')) {
    mask = mask.substring(1);
  }
  return mask;
};

export const getPhonePlaceholder = (iso2: string): string => {
  const mask = getPhoneMask(iso2);
  return mask ? mask?.replace(/\./g, '_') : '';
};

export const formatPhoneByMask = (value: string, iso2: string): string => {
  const mask = getPhoneMask(iso2);
  if (!mask) return value;

  const digits = value?.replace(/\D/g, '');
  let result = '';
  let digitIdx = 0;

  for (let i = 0; i < mask.length && digitIdx < digits.length; i++) {
    if (mask[i] === '.') {
      result += digits[digitIdx];
      digitIdx++;
    } else {
      result += mask[i];
    }
  }

  return result;
};

export const getMaxPhoneDigits = (iso2: string): number => {
  const mask = getPhoneMask(iso2);
  if (!mask) return 15;
  return (mask.match(/\./g) || []).length;
};

export const isPhoneComplete = (value: string, iso2: string): boolean => {
  const digits = value?.replace(/\D/g, '');
  return digits.length === getMaxPhoneDigits(iso2);
};

export const parseInternationalNumber = (number: string): { iso2: string; localNumber: string } => {
  if (!number || !number.startsWith('+')) {
    return { iso2: 'ae', localNumber: '' };
  }

  const digits = number.substring(1);

  const sorted = [...allCountries].sort((a, b) => b.dialCode.length - a.dialCode.length);

  for (const country of sorted) {
    if (digits.startsWith(country.dialCode)) {
      const local = digits.substring(country.dialCode.length);
      const formatted = formatPhoneByMask(local, country.iso2);
      return { iso2: country.iso2, localNumber: formatted };
    }
  }

  return { iso2: 'ae', localNumber: '' };
};

export const phoneCodeOptions = allCountries
  .map((country) => {
    const iso3 = getIso3(country.iso2);
    const displayLabel = `${iso3} +${country.dialCode}`;
    return {
      value: country.iso2,
      label: `+${country.dialCode}`,
      displayLabel,
      searchLabel: `${iso3} ${cleanCountryName(country.name)} +${country.dialCode}`,
      flagClass: `fi fi-${country.iso2}`,
    };
  })
  .sort((a, b) => a.displayLabel.localeCompare(b.displayLabel));
